<template>
  <div>
    <div class="mb-1">
      <span class="contacto">Contacto</span><br>
      <img src="@/assets/footer/icon-mail.svg" width="8%"> <span class="info-abacolatam-com">info@abacolatam.com</span><br>

      <img src="@/assets/footer/icon-phone.svg" width="8%"> <span class="info-abacolatam-com">3183061739</span><br>
      <a href="https://www.instagram.com/abaco_latam/" class="footer-link" target="_blank"><img src="@/assets/footer/instagram.svg" width="8%"> <span class="info-abacolatam-com">@abaco_latam</span></a><br>
      <a href="https://www.facebook.com/AbacoLatamMicrocreditos" class="footer-link" target="_blank"><img src="@/assets/footer/facebook.svg" width="8%"> <span class="info-abacolatam-com">Ábaco Latam</span></a><br>
    </div>
    <div>
      <router-link to="/legal" class="info-abacolatam-com" style="color: blue" @click.native="scrollToTop">
        Política de tratamiento de la información
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FooterContact'
}
</script>

<style>
.footer-link {
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/partials/FooterContact.vue